import React from 'react'

import Button from '@material-ui/core/Button'

import { observer } from 'mobx-react'
import { useRouterStore } from 'mobx-state-router'
import { useRootStore } from 'contexts'


import axios from 'axios'

import { TICKETS_CREATE_DOWNLOAD_ENDPOINT } from 'Api'

import FixedToolbar from 'components/FixedToolbar'
import MainLayoutVh from 'layouts/MainVh'

import TextSearch from 'components/search/TextSearch'
import CheckBoxFilter from 'components/search/CheckBoxFilter'
import TicketsTableVirtualized from './components/TicketsTableVirtualized'
import TextField from 'jimbo/ui/TextField'

const TicketsScreen = observer(() => {

  const routerStore = useRouterStore()
  const rootStore = useRootStore()
  const {ticketsStore, authStore} = rootStore

  const nrOfTicketsField =  ticketsStore.ticketsCsvDownload.$fields.get("nrOfTickets");

  const newTicket = () => {
     ticketsStore.createNewTicket()
  }

  const newTicketBatch = () => {
    routerStore.goTo('newTicketBatch');
  }

  const onSelectObject = id => {
     //routerStore.goTo('notification', { params: { id } });
  }


  const createAndDownloadTickets = () => {
           //const organisationId = authStore.selectedOrganisation.id
           
    if (nrOfTicketsField.valid ){
           const nrOfTickets = nrOfTicketsField.value

           const contentId = ticketsStore.getPublishedContentId()
           const createBatchTicketUrl = `${TICKETS_CREATE_DOWNLOAD_ENDPOINT}/${contentId}/`
           axios({
               url: createBatchTicketUrl,
               method: 'POST',
               responseType: 'blob',
               data: {
                nrOfTickets
               }
           })
               .then((response) => {
                   const url = window.URL.createObjectURL(new Blob([response.data]));
                   const link = document.createElement('a');
                   link.href = url;
                   link.setAttribute('download', 'tickets.csv');
                   document.body.appendChild(link);
                   link.click();
                   document.body.removeChild(link);
                   ticketsStore.loadObjects()
               })
   
      }
    }


  const toolbar = <FixedToolbar>
      <TextSearch store={ticketsStore} searchTerm="ticketCode"/>
      <CheckBoxFilter label="is used" store={ticketsStore} filterName="used" filterValue="true"/>
      <CheckBoxFilter label="sold" store={ticketsStore} filterName="sold" filterValue="true"/>
      <Button color="primary" variant="contained" onClick={() => newTicket()}>Add a ticket</Button>
      <div style={{width: 200, color: "white"}}>
        <TextField 
        id="001" 
        label="Nr" 
        instance={ticketsStore.ticketsCsvDownload} 
        fieldName="nrOfTickets" />
      </div>
      <Button color="primary" variant="contained" onClick={() => createAndDownloadTickets()}>Add and download tickets</Button>
      
    </FixedToolbar>

  return <MainLayoutVh toolbar={toolbar} >
        <TicketsTableVirtualized  store={ticketsStore} onSelectObject={onSelectObject} />
    </MainLayoutVh>;
});

export default TicketsScreen;

// <Button color="primary" variant="contained" onClick={() => newTicketBatch()}>Add a ticket batch</Button>